import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TowersItemStatusEnum } from '../interfaces/towers.interface';
import { BalanceType } from '@core/types/balance.type';
import { DecimalPipe } from '@angular/common';
import { BalanceIconComponent } from '../../../core/components/balance-icon/balance-icon.component';

@Component({
  selector: 'app-towers-item',
  templateUrl: './towers-item.component.html',
  styleUrls: ['./towers-item.component.scss'],
  standalone: true,
  imports: [BalanceIconComponent, DecimalPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TowersItemComponent {
  readonly state = input.required<TowersItemStatusEnum>();
  readonly multiplier = input.required<number>();
  readonly picked = input.required<boolean>();
  balance = input.required<BalanceType>();
}
